(function () {
  GDPRController.$inject = ["API_URL", "$http", "$cookies", "$rootScope", "$timeout"];
  angular.module('userApp').controller('GDPRController', GDPRController);

  function GDPRController(API_URL, $http, $cookies, $rootScope, $timeout) {
    var gdpr = this;
  }
})();